// extracted by mini-css-extract-plugin
module.exports = {"headerLayout":"HeaderBar_headerLayout__3tllX","desktopContainer":"HeaderBar_desktopContainer__8dKPK","mobileContainer":"HeaderBar_mobileContainer__Mh4Fm"};